export const ENDPOINTS = {
    GET_STAKING_ENABLE: '/api/staking',
    GET_KYC: '/api/kycs'
};